class CoreSlideshow extends HTMLElement {

    constructor() {
        super();
        this.data = {
            index: 0,
            isInViewport: false
        }
        this.prev = this.prev.bind(this);
        this.next = this.next.bind(this);
        this.onBulletClick = this.onBulletClick.bind(this)
        this.onIntersect = this.onIntersect.bind(this)
    }

    onIntersect(e) {
        if(e[0].isIntersecting && !this.data.isInViewport) {
            this.data.isInViewport = true
            this.updateSlides()
            this.onAutoChange()
        }
    }

    next() {
        clearTimeout(this.autoTimer)
        this.classList.remove('is-auto')
        this.data.index++
        this.updateSlides()
    }

    prev() {
        clearTimeout(this.autoTimer)
        this.classList.remove('is-auto')
        this.data.index--;
        this.updateSlides();
    }

    onBulletClick(event) {
        clearTimeout(this.autoTimer)
        this.classList.remove('is-auto')
        this.data.index = +event.currentTarget.dataset.index
        this.updateSlides();
    }

    onAutoChange() {
        this.classList.add('is-auto')
        this.autoTimer = setTimeout(() => {
            this.data.index += 1
            this.updateSlides()
            this.onAutoChange()
        }, 10 * 1000)
    }

    updateSlides() {
        this.data.index = this.data.index > this.$slides.length-1 ? 0 : this.data.index;
        this.data.index = this.data.index < 0 ? this.$slides.length-1 : this.data.index;

        this.$slides.forEach((el,i)=>{
            el.classList[ i == this.data.index ? 'add' : 'remove' ]( 'is-active' );
            if (i == this.data.index) {
                el.removeAttribute('tabindex');
                el.style.pointerEvents = 'auto';
                el.removeAttribute('aria-hidden');
                el.focus();
                this.$bulletBtns[i].classList.add('is-active')
            }
            else {
                el.setAttribute('tabindex', -1);
                el.style.pointerEvents = 'none';
                el.setAttribute('aria-hidden', true);
                this.$bulletBtns[i].classList.remove('is-active')
            }
        });
    }

    connectedCallback() {
        this.$slides = this.querySelectorAll('[data-slide]');
        this.$prevBtn = this.querySelector('[data-prev-btn]');
        this.$nextBtn = this.querySelector('[data-next-btn]');
        this.$bulletBtns = this.querySelectorAll('[data-bullet-btn]')
        this.$prevBtn.addEventListener('click', this.prev, false);
        this.$nextBtn.addEventListener('click', this.next, false);
        this.$bulletBtns.forEach((btn) => {
            btn.addEventListener('click', this.onBulletClick, false);
        })

        this._observer = new IntersectionObserver(this.onIntersect)
        this._observer.observe(this);
    }

    disconnectedCallback() {
        this._observer.unobserve(this);
        this.$prevBtn.removeEventListener('click', this.prev, false);
        this.$nextBtn.removeEventListener('click', this.next, false);
        this.$bulletBtns.forEach((btn) => {
            btn.removeEventListener('click', this.onBulletClick, false);
        })
    }

}

customElements.define('core-slideshow', CoreSlideshow);


console.log('<core-slidehow> loaded');